import data from "../../data/index.json";

export default function MyServices() {
  return (
    <section className="skills--section" id="Services">
      <div className="portfolio--container">
        <p className="section--title">SERVICES</p>
        <h2 className="skills--section--heading">OUR EXPERTISE</h2>
      </div>
      <div className="skills--section--container">
        {data?.services?.map((item, index) => (
          <div key={index} className="skills--section--card">
            <div className="skills--section--img">
              <img src={item.src} alt="image" />
            </div>
            <div className="skills--section--card--content">
              <h3 className="skills--section--title">{item.title}</h3>
              <p className="skills--section--description">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
